<template>
  <div
    v-if="paymentType === 'sales'"
    class="paymentWrapper goldenbg"
  >
    <b-row>
      <b-col cols="12">
        <div class="pmLogo floatCss">
          <img :src="pmLogoImg">
        </div>
      </b-col>
    </b-row>

    <b-row v-if="showPayment && !alreadyPaid">
      <b-col cols="12">
        <div class="pmSubmissionWrapper floatCss">
          <h1>Make Payment for Submission Number {{ submissionDetail.stringID }}</h1>
          <p>Please take a moment to complete your payment for your sales order. The link is valid for a limited time, so kindly ensure you make the payment before it expires.</p>
          <p>This link is specifically for <strong>Submission Number {{ submissionDetail.stringID }}</strong>. Thank you!</p>
          <p>This payment link will expire on <span>{{ dateFormatWithFormatParam(tokenDetail.expiresAt, 'DD MMM YYYY, hh:mma') }}</span>.</p>
          <div class="startBtnpm floatCss">
            <b-button
              class="sts-pm-btn"
              :to="{ name: 'sales-payment-frontend-review', params: { token: $route.params.token } }"
            >
              <span><img :src="pmArrowRightImg"></span>Let’s get started!
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-else-if="alreadyPaid">
      <b-col cols="12">
        <div class="pmSubmissionWrapper linkgapPm floatCss">
          <h1>Submission Number {{ submissionDetail.stringID }} has already been paid for.</h1>
          <p>No further payments is required for this Sales Order at this point. </p>
          <p>For more information, you can speak to {{ submissionDetail.serviceAgentName || 'the agent serving you' }}, the agent serving you for this Sales Order.</p>
        </div>
      </b-col>
    </b-row>

    <b-row v-else-if="tokenExpired">
      <b-col cols="12">
        <div class="pmSubmissionWrapper linkgapPm floatCss">
          <h1>Payment link for Submission Number {{ submissionDetail.stringID }} has expired.</h1>
          <p>This payment link is no longer valid, please check with {{ submissionDetail.serviceAgentName || 'the agent serving you' }}, the agent serving you for this Sales Order.</p>
          <p>No payment has been processed.</p>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="showPayment && !alreadyPaid">
      <b-col cols="12">
        <div class="paymentMethodBrand floatCss">
          <div class="scrPm">
            Secure payment
          </div>
          <div class="scrPm-photo">
            <img :src="methodPhotoImg">
          </div>
        </div>
      </b-col>
    </b-row>
  </div>

  <div
    v-else
    class="p4b__parent p4b__pb-40"
  >
    <div
      v-show="$store.state.appConfig.showLoader"
      class="axios-loader"
    >
      <loader />
    </div>
    <div class="container">
      <div class="p4b__toc-logo">
        <img
          :src="logoImg"
          alt="Logo"
        >
      </div>
      <b-card
        v-if="showPayment"
        class="p4b__make-payment-card"
      >
        <b-card-text class="p4b__make-payment-card__content">
          <h4>Make Payment for #{{ fileDetail.fileNo }}</h4>
          <p>Please take a moment to complete your payment for your {{ feeItems }}. The link is valid for a limited time, so kindly ensure you make the payment before it expires.</p>
          <p>This link is specifically for <strong>{{ fileDetail.nvsFileType }} {{ fileDetail.lotLocation }} (File no. {{ fileDetail.fileNo }}).</strong> Thank you!</p>
          <p>This payment link will expire on <span>{{ dateFormatWithFormatParam(tokenDetail.expiresAt, 'DD MMM YYYY, hh:mma') }}</span>.</p>
          <b-button
            class="p4b__payment-btn-common"
            block
            :to="{ name: 'file-payment-frontend', params: { token: $route.params.token } }"
          >
            <feather-icon
              icon="ArrowRightIcon"
              size="12"
              style="vertical-align: middle;"
            />
            Let’s get started
          </b-button>
        </b-card-text>
      </b-card>
      <div class="p4b__make-payment-logo">
        <p> <feather-icon
          icon="ShieldIcon"
          size="14"
        /> Secure payment</p>
        <div class="p4b__logo-wrapper">
          <b-img
            :src="visaCard"
            height="10.32px"
            alt="visaCard"
          />
          <b-img
            :src="masterCard"
            height="20px"
            alt="masterCard"
          />
          <b-img
            :src="payNow"
            height="18px"
            alt="payNow"
          />
          <b-img
            :src="googlePay"
            height="22px"
            alt="googlePay"
          />
          <b-img
            :src="grabPay"
            height="20px"
            alt="grabPay"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BButton, BCard, BCardText, BImg, BRow, BCol,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loader from '../Loader.vue'

export default {
  components: {
    BButton,
    BCard,
    BCardText,
    BImg,
    BRow,
    BCol,

    Loader,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/frontend/p4b/logo-yellow.png'),
      // eslint-disable-next-line global-require
      visaCard: require('@/assets/images/frontend/p4b/payment-logo/visa_4x.png'),
      // eslint-disable-next-line global-require
      masterCard: require('@/assets/images/frontend/p4b/payment-logo/master_4x.png'),
      // eslint-disable-next-line global-require
      grabPay: require('@/assets/images/frontend/p4b/payment-logo/grabpay_4x.png'),
      // eslint-disable-next-line global-require
      payNow: require('@/assets/images/frontend/p4b/payment-logo/paynow_4x.png'),
      // eslint-disable-next-line global-require
      googlePay: require('@/assets/images/frontend/p4b/payment-logo/googlepay_4x.png'),
      // eslint-disable-next-line global-require
      pmLogoImg: require('@/assets/images/mobile/pmLogo.png'),
      // eslint-disable-next-line global-require
      pmArrowRightImg: require('@/assets/images/mobile/pmarrow-right.png'),
      // eslint-disable-next-line global-require
      methodPhotoImg: require('@/assets/images/mobile/method-photo.png'),
      agreeWithToc: false,
      showPayment: false,
      fileDetail: {},
      tokenDetail: {},
      feeItems: '',
      paymentType: null,
      submissionDetail: {},
      alreadyPaid: false,
      tokenExpired: false,
    }
  },

  beforeMount() {
    const { token } = this.$route.params
    if (token) {
      this.$http.get('front-end/payment/validate/token', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.type === 'sales') {
              this.paymentType = 'sales'
              this.tokenDetail = response.data.token || {}
              this.submissionDetail = response.data.submission || {}
              if (response.data.validToken) {
                this.showPayment = true
                this.alreadyPaid = !!response.data.alreadyPaid
              } else {
                this.tokenExpired = true
              }
              return
            }

            document.body.classList.add('p4b__payment-bg')
            if (response.data.validToken) {
              this.showPayment = true
              this.fileDetail = response.data.file || {}
              this.tokenDetail = response.data.token || {}
              const items = []

              if (this.fileDetail.installmentSchedule && this.fileDetail.installmentSchedule.length > 0) {
                const filteredInstallments = this.fileDetail.installmentSchedule.filter(
                  o => o.paymentStatus !== 'Paid',
                )
                if (filteredInstallments.length) {
                  items.push('installments')
                }
              }

              if (response.data.reactivationFees.length) {
                items.push('reactivation fees')
              }

              if (response.data.invoices.length) {
                items.push('invoices')
              }
              let text = ''
              if (items.length === 1) {
                // eslint-disable-next-line prefer-destructuring
                text = items[0]
              } else if (items.length === 2) {
                text = `${items[0]} and ${items[1]}`
              } else if (items.length > 2) {
                text = `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`
              }
              this.feeItems = text
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
}
</script>
